<script lang="ts">
export default {
    name: "Layouts",
}
</script>

<script setup lang="ts">
import MainViewer from "@/components/viewer/index.vue"
import SideBar from "./components/side-bar.vue"
import LeftHeader from "./components/left-header.vue"
import RightHeader from "./components/right-header.vue"
</script>

<template>
    <div class="width-100vw height-100vh mian-container">
        <main-viewer >
            
        </main-viewer>
        <div class="contianer"> 
            <div class="width-100vw flex-display flex-justify-between header-box" style="pointer-events:all;">
                <left-header />
                <side-bar />
                <right-header />
            </div>
            <router-view />
        </div>
    </div>
</template>

<style scoped lang="scss">
.contianer{
    position: absolute;

    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1;
    pointer-events: none;
    .header-box{
        position: absolute;
        top: 0;
        height: 12vh;
        background: url("@/assets/images/header-bg.png") center no-repeat;
        background-size: 100% 100%;
        z-index: 1;
        background-color: rgb(0,83,126);
    }
}
</style>
